<template>
  <div>
    <h1 class="headline">{{headerText}}</h1>
    <p>{{snippet}}</p>

    <!-- Name On Title -->
    <mdl-textfield
      field-id="contactName"
      :label="nameLabelText"
      placeholder="eg. Lisa Simpson"
      @inputting="updateInput"
      :bvalue="contact.name"
      @enter-pressed="focusNextInput"
      ></mdl-textfield>

    <!-- Email -->
    <mdl-textfield
      field-id="contactEmail"
      type="email"
      :label="emailLabelText"
      placeholder="eg. lisa.simpson@example.com"
      @inputting="updateInput"
      :bvalue="contact.email"
      @enter-pressed="focusNextInput"
      ></mdl-textfield>

    <div class="App-buttons">
      <button-component
        direction="back"
        value="Back"
        ></button-component>
      <button-component
        color="primary"
        value="Next Step"
        :is-disabled="isDisabled"
        field-id="buttonContactNext"
        ></button-component>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ButtonComponent from '@/components/Button.vue';
import mdlTextfield from '@/components/mdlTextfield.vue';
import {isEmail} from 'validator';
import {mapActions, mapGetters} from 'vuex';

export default {
  components: {
    ButtonComponent,
    mdlTextfield
  },
  computed: {
    ...mapGetters({
      contact: 'contact/contact',
      trackingCode: 'trackingCode',
      displayOptions: 'displayOptions'
    }),
    isDisabled() {
      // Is it a valid email?
      if (!this.contact.email || !isEmail(this.contact.email)) {
        return true;
      }
      // Check if name and email provided
      if (!this.contact.name) {
        return true;
      }
      // Otherwise not valid
      return false;
    }
  },
  data() {
    return {
      headerText: 'What is your name and email address?',
      snippet:
        'Your info will be used to verify ownership. A copy of the completed proxy will be emailed to you.',
      nameLabelText: 'Your Name On Title',
      emailLabelText: 'Your Email Address'
    };
  },
  methods: {
    ...mapActions('contact', ['setContactItem']),
    focusNextInput(currentInput) {
      const isContactName = currentInput === 'contactName';
      const nextInput = isContactName ? 'contactEmail' : 'buttonContactNext';
      this.$events.$emit('go-input', nextInput);
    },
    updateInput(value, prop) {
      this.setContactItem({prop, value});
    },
    setCustomText() {
      if (!_.has(this.displayOptions, 'contact')) {
        return;
      }
      const contactOpts = this.displayOptions.contact;
      this.headerText = contactOpts.header_text || this.headerText;
      this.snippet = contactOpts.snippet || this.snippet;
      this.nameLabelText = contactOpts.name_label_text || this.nameLabelText;
      this.emailLabelText = contactOpts.email_label_text || this.emailLabelText;
    }
  },
  mounted() {
    this.setCustomText();
    this.$nextTick(() => {
      componentHandler.upgradeAllRegistered();
    });
  }
};
</script>
